import React, { useState, ReactNode } from "react";
import { IDefaultMenuProps, Menu } from "../default/index";
import styles from "./styles.module.scss";
import { IconButton } from "VideoWall/components/buttons/icon";
import { MenuIcon, MoreIcon } from "VideoWall/components/icons";

interface IProps extends IDefaultMenuProps {
  menuIconClose?: ReactNode;
  menuIconOpen?: ReactNode;
  disabled?:boolean
}

export const ResponsiveMenu = ({
  className,
  menuIconClose,
  menuIconOpen,
  disabled,
  ...rest
}: IProps) => {
  const [opened, setOpened] = useState(false);
  const menuOpenedIcon = menuIconOpen ? menuIconOpen : <MenuIcon />;
  const menuCloseIcon = menuIconClose ? menuIconClose : <MoreIcon />;
  return (
    <div className={`${styles.root} ${className}`}>
      <IconButton
        disabled={disabled}
        onClick={() => setOpened(!opened)}
        icon={opened ? menuCloseIcon : menuOpenedIcon}
      />
      <div className={`${styles.menu} ${opened && styles.active}`}>
        <Menu {...rest} />
      </div>
    </div>
  );
};
